import React from 'react';

import useTab from '../../../store/hooks/useTab';
import TabBar from '../../../components/Tab/TabBar';
import Console from './Console';
import Memberships from './Memberships';
import Analytics from './Analytics';

const CONSOLE = 'console';
const MEMBERSHIPS = 'memberships';
const ANALYTICS = 'analytics';
const TABS = [CONSOLE, MEMBERSHIPS, ANALYTICS];

export default function EventSync() {
  const selectedTab = useTab(TABS);

  return (
    <TabBar tabs={TABS} selectedTab={selectedTab}>
      <Console tab={CONSOLE} />
      <Memberships tab={MEMBERSHIPS} />
      <Analytics tab={ANALYTICS} />
    </TabBar>
  );
}